import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { TextField, InputLabel } from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'

const FormSearchField = ({
                           formActions, classes, name, setReturnedObj, labelKey, list, required, row, small, large,
                           entityKey = 'name', disabled, selectFirst, locale, load, filterFunction, placeholderKey
                         }) => {
  const intl = useIntl()
  const [selectedValue, setSelectedValue] = React.useState('')
  const [isInitValueLoaded, setIsInitValueLoaded] = React.useState(false)

  React.useEffect(() => {
      if ((!!list.length && !isInitValueLoaded) || !!load) {
        let matched = list.filter((item) => formActions.values[name]?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا') === item[!!locale ? `${entityKey}_${locale}` || `${entityKey}_en` : entityKey]?.replaceAll(/ـ/gi, '')?.replaceAll(/أ|إ/gi, 'ا'))
        setSelectedValue(matched?.length ? matched[0]: formActions.values[name])
        !!selectFirst && matched?.length && setReturnedObj(matched[0])
        setIsInitValueLoaded(true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [list, load])

  let newClasses = [
    !!row ? classes.FormRow : '',
    !!small ? classes.FormSmall : '',
    !!large ? classes.FormLarge : ''
  ].filter(item => !!item).join(' ')
  return (
    <div className={classes.FormItem + ` ${newClasses}`}>
      <InputLabel htmlFor={name}><FormattedMessage id={labelKey}/>{!!required &&
      <span className={'required'}>*</span>}:</InputLabel>
      <div className={classes.autoCompleteWrapper}>
        <Autocomplete
          id={name}
          options={list || []}
          value={selectedValue || null}
          disabled={disabled}
          freeSolo
          selectOnFocus={true}
          getOptionLabel={(option) => (!!locale ? option[`name_${locale}`] || option['name_en'] : option?.name) || option}
          onInputChange={(event, newInputValue) => {
            if (newInputValue?.length && event?.type === 'change') {
              formActions.setFieldValue(name, newInputValue)
              if (!!setReturnedObj) {
                setReturnedObj(null)
              }
            }
          }}
          onChange={(event, value) => {
            setSelectedValue(value)
            formActions.setFieldTouched(name, true, true)
            formActions.setFieldValue(name, !!Object.keys(value || {})?.length ? (value[!!locale ? `${entityKey}_${locale}` || `${entityKey}_en` : entityKey] || '') : (value || ''))
            if (!!setReturnedObj) {
              setReturnedObj(value)
            }
          }}
          forcePopupIcon={true}
          // renderOption={!!renderOption ? renderOption : (option, { selected }) => (!!locale ? option[`name_${locale}`] || option['name_en'] : option?.name) || option}
          renderInput={(params) => (
            <TextField {...params} variant="outlined"
                       placeholder={intl.formatMessage({ id: placeholderKey || labelKey })}
                       name={name}
                       onBlur={formActions.handleBlur}
                       helperText={formActions.errors[name] && formActions.touched[name] && formActions.errors[name]}
                       error={formActions.errors[name] && formActions.touched[name] !== undefined}
            />
          )}
          {...filterFunction}
        />
      </div>
    </div>
  )
}

export default FormSearchField
